import React from 'react'

import DotsSvg from '@/assets/img/dots.svg'
import ProfileIcon from '@/assets/img/ico-view-profile.svg?react'
import Dropdown from '@/compoments/common/Dropdown'
import { PillStatus } from '@/compoments/common/PillStatus'
import UserPart from '@/compoments/common/UserPart'
import DropdownList from '@/compoments/DropdownList'
import type { TechnicianPerfomance } from '@/types/executives'
import { useNavigate } from 'react-router-dom'
interface TableProps {
    data?: TechnicianPerfomance[]
}
const Table = ({ data }: TableProps) => {
    return (
        <table className="table">
            <thead>
                <tr>
                    <th>Full Name</th>
                    <th>Phone</th>
                    <th>Job & Company</th>
                    <th style={{ minWidth: 125 }}>Skills</th>
                    <th style={{ minWidth: 145 }}>Certificates</th>
                    <th>Status</th>
                    <th>Rating</th>
                    <th>Jobs Completed</th>
                    <th style={{ width: 10 }}>Actions</th>
                </tr>
            </thead>
            <tbody>
                {data && data?.length > 0 ? (
                    data.map((technician, index) => (
                        <tr key={index}>
                            <td>
                                <UserPart
                                    name={technician.fullName}
                                    email={technician.email}
                                />
                            </td>
                            <td>
                                <span className="text--xs">
                                    {technician.phone}
                                </span>
                            </td>
                            <td>
                                <div className="flex flex-col">
                                    <span className="text--xs fw-500">
                                        {technician.userInfo.jobTitle}
                                    </span>
                                    <span className="text--12 text-color-1">
                                        {technician.userInfo.companyName}
                                    </span>
                                </div>
                            </td>
                            <td>
                                <span className="text--xs text-color-1 text-wrap">
                                    {technician.userInfo.skills.join(', ')}
                                </span>
                            </td>
                            <td>
                                <span className="text--xs text-color-1 text-wrap">
                                    {technician.userInfo.certificates.join(
                                        ', ',
                                    )}
                                </span>
                            </td>
                            <td>
                                <PillStatus status={technician.workStatus} />
                            </td>
                            <td>
                                <div className="flex flex-col">
                                    <span className="text--xs fw-500">
                                        {technician.rating}
                                    </span>
                                    <span className="text--12 text-color-1">
                                        Rank {technician.rank}
                                    </span>
                                </div>
                            </td>
                            <td className="text-center">
                                <span className="fw-600 text--xs color-primary">
                                    {technician.completedOrders}
                                </span>
                            </td>
                            <td className="text-right sticky-end">
                                <Dropdown
                                    closeSelf={true}
                                    dropdownClasses="flex flex-col"
                                    button={
                                        <span className="ico">
                                            <img src={DotsSvg} alt="" />
                                        </span>
                                    }
                                    menuClassName="dropdown-md"
                                    menu={<DropdownList list={[]} />}
                                />
                            </td>
                        </tr>
                    ))
                ) : (
                    <tr>
                        <td colSpan={9}>
                            <h4 className="text-center">
                                Technician Performance not found
                            </h4>
                        </td>
                    </tr>
                )}
            </tbody>
        </table>
    )
}

export default Table
